<script setup>
import { ImageIcon } from 'lucide-vue-next'

defineProps({
  photos: { type: Array, required: true },
})
</script>

<template>
  <p v-if="!photos.length" class="text-sm text-slate-500">
    Nenhuma foto do serviço ainda.
  </p>

  <ul v-else class="grid grid-cols-2 gap-3">
    <li v-for="photo in photos" :key="photo.id">
      <!--
        Com imagem anexada, o item vira link para abrir a foto em tamanho
        cheio. Sem imagem, continua um bloco estático: nada de placeholder
        clicável que não leva a lugar nenhum.
      -->
      <component
        :is="photo.url ? 'a' : 'div'"
        v-bind="photo.url ? { href: photo.url, target: '_blank', rel: 'noopener' } : {}"
        class="group block w-full overflow-hidden rounded-lg border border-slate-100 text-left"
      >
        <img
          v-if="photo.url"
          :src="photo.url"
          :alt="`Foto do serviço: ${photo.caption}`"
          loading="lazy"
          class="aspect-[4/3] w-full bg-slate-100 object-cover transition-opacity group-hover:opacity-90"
        >
        <!-- Sem arquivo de imagem: placeholder, nunca uma foto fictícia. -->
        <span
          v-else
          class="flex aspect-[4/3] items-center justify-center bg-slate-100"
          role="img"
          :aria-label="`${photo.caption}: foto ainda não enviada`"
        >
          <ImageIcon class="h-7 w-7 text-slate-400" aria-hidden="true" />
        </span>

        <span class="block px-3 py-2">
          <span class="block truncate text-xs font-medium text-up-navy">{{ photo.caption }}</span>
          <span class="block text-[11px] text-slate-500">{{ photo.at }}</span>
        </span>
      </component>
    </li>
  </ul>
</template>
